module.exports = __webpack_public_path__ + "img/icon-settings.e54c0583.svg";